<script>
import Multiselect from "vue-multiselect";
import config from "../../config";
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import DropzonePopup from '../../components/widgets/dropzone-popup';
import { error_message, get_user, success_message } from "../../Helper/helper";
import { vendorService, deliveryZoneService, settingService, userService } from "../../services";

import { required,email,numeric,helpers,requiredIf} from "vuelidate/lib/validators";
const floating = helpers.regex('floating', /^(?:\d*\.\d{1,2}|\d+)$/)

/**
 * Add-product component
 */
export default {
  components: { Multiselect,VueGoogleAutocomplete, DropzonePopup},
  data() {
    return {
      file1: null,
      url: null,
      config: config,
      search: '',
      isLoading: false,
      center: { lat: 0.00, lng: 0.00 },
      marker: null,
      edited: null,
      countries: [],
      states: [],
      cities: [],
      filename: "",
      vendor_currency:'',
      country_count:'',
      state_count:'',
      city_count:'',
      typeform: {
        name: "",
        email: "",
        phone: "",
        country: "",
        state: "",
        city: "",
        address: "",
        location_address: "",
        minimum_order_value: "",
        delivery_type_time_slots: 2,
        currency: "",
        restaurant_tax: "",
        icon_image: null,
        latitude:"",
        longitude: "",
        name_thai: "",
        address_thai: "",
        payment_option: "Both"
      },
      map: null
    };
  },
  validations: {
    typeform: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
        // numeric,
      },
      country: {
        required,
      },
      city: {
        required,
      },
      state: {
        required,
      },
      address: {
        required,
      },
      location_address: {
        required,
      },
      minimum_order_value: {
        required,
        floating
      },
      restaurant_tax: {
        floating
      },
      icon_image: {
        required
      }
    },
  },
  mounted() {
    this.initMap();
    this.getVendorCountry();
    this.getSetting();
    this.$refs.address.focus();
    this.vendor_id = get_user().vendor_id || 40818;
  },
  methods: {
    initMap(){
      this.map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: -34.397, lng: 150.644 },
        zoom: 8,
      });
    },
    floatingNumber(e){   
      const floating = /^[0-9.]\d*(\.\d{1,2})?$/;
      let char = String.fromCharCode(e.keyCode);
      if (floating.test(char)) return true;
      else e.preventDefault();
    },
    userCheckEmail(e) {
      userService.userCheckEmail({
        email:this.typeform.email,
        table:'User',
        column:'user_id',
        vendor_id:this.vendor_id,
        user_role:'2'
      })
      .then(response => {
        if (response.data.code === 101) {
          error_message(response.data.message);
        }
      });
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.address = addressData;
      this.typeform.address = placeResultData.formatted_address;
      this.typeform.latitude = addressData.latitude;
      this.typeform.longitude = addressData.longitude;
      if(this.marker) {
        this.marker.setMap(null)
      }
      const marker = {
        lat: addressData.latitude,
        lng: addressData.longitude
      };
      const latlng = new google.maps.LatLng(addressData.latitude,addressData.longitude)
      this.marker = new google.maps.Marker({
        position: latlng,
        title:"Restaurant"
      });
      this.marker.setMap(this.map);
      this.map.setCenter(latlng);
      this.center = marker;
      this.map.setZoom(14);
    },
    getSetting(){
      settingService.getSetting()
      .then(response => {
        const cent = {
          lat: parseFloat(response.data.result.system_latitude),
          lng: parseFloat(response.data.result.system_longitude)
        };
        this.center = cent; 
        const latlng = new google.maps.LatLng(response.data.result.system_latitude,response.data.result.system_longitude)
        this.marker = new google.maps.Marker({
          position: latlng,
          title:"Restaurant"
        });
        this.marker.setMap(this.map);
        this.map.setCenter(latlng);
        this.map.setZoom(8);
        this.vendor_currency = response.data.result.currency;
      });
    },
    getVendorCountry() {
      this.typeform.state = '';
      this.typeform.city = '';
      this.states = [];
      this.cities = [];
      deliveryZoneService.getVendorCountry().then((response) => {
        this.country_count = response.data.result.length;
        this.countries = response.data.result;
        if (this.country_count == 1) {
          this.typeform.country = this.countries[0].id;
          this.getVendorState();
        }
      });
    },
    getVendorState() {
      this.states = [];
      this.cities = [];
      this.city_count = 0;
      this.state_count = 0;
      this.typeform.city = '';
      if(!this.typeform.country) return false;
      deliveryZoneService.getVendorState({country_id: this.typeform.country}).then((response) => {
        this.state_count = response.data.result.length;
        this.states = response.data.result;
        if (this.state_count == 1) {
          this.typeform.state = this.states[0].id;
          this.getVendorCity();
        }
      });
    },
   getVendorCity() {
      this.cities = [];
      this.city_count = 0;
      if(!this.typeform.state) return false;
      deliveryZoneService.getVendorCity({state_id: this.typeform.state}).then((response) => {
        this.city_count = response.data.result.length;
        this.cities = response.data.result;
        if (this.city_count == 1) {
          this.typeform.city = this.cities[0].cityid;
        }
      });
    },
    getAllState() {
      deliveryZoneService.getAllState()
        .then((response) => {
        this.states = response.data.result;
        this.state_count = response.data.result.length;
      });
    },
    getAllCity() {
      deliveryZoneService.getAllCity().then((response) => {
        this.cities = response.data.result;
        this.city_count = response.data.result.length;
      });
    },
    vendorAdd() {
      this.$v.typeform.$touch();
      if (this.$v.typeform.$invalid) {
        setTimeout(()=>{
            $('html, body').animate({
                scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
            }, 500, function() {
                $(".is-invalid:first").focus();
            });
        },500);
        return;
      } else {
        const fd = new FormData();
        fd.append("name", this.typeform.name);
        fd.append("email", this.typeform.email);
        fd.append("phone", this.typeform.phone);
        fd.append("country", this.typeform.country);
        fd.append("state", this.typeform.state);
        fd.append("city", this.typeform.city);
        fd.append("address", this.typeform.address);
        fd.append("location_address", this.typeform.location_address);
        fd.append("minimum_order_value", this.typeform.minimum_order_value);
        fd.append("currency", this.typeform.currency);
        fd.append("restaurant_tax", this.typeform.restaurant_tax);
        fd.append("latitude", this.typeform.latitude);
        fd.append("longitude", this.typeform.longitude);
        fd.append("name_thai", this.typeform.name_thai);
        fd.append("address_thai", this.typeform.address_thai);
        fd.append("delivery_type_time_slots", this.typeform.delivery_type_time_slots);
        fd.append("payment_method",this.typeform.payment_option);
        fd.append("icon_image", this.typeform.icon_image);
        vendorService.addVendor(fd).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "vendor-list" });
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
    filterInput(e){
      e.target.value = e.target.value.replace(/[^0-9]+/g, '');
    },
    contactNumber(evt) {
      let val1 = evt.target.value;
      if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
        evt.preventDefault();
      }
      let partlen = val1.split("+").length - 1;
      if (evt.keyCode == 43 && partlen > 0) {
        evt.preventDefault();
      } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
        evt.preventDefault();
      }
    }
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <form @submit.prevent="vendorAdd">
        <!-- Vendor Info Start -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{ trans.trans('__JSON__.Vendor Info',{ vendor:  $auth.setting && $auth.setting.restaurant_name })}}</h4>
            <p class="card-title-desc"></p>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group" v-if="$auth.setting">
                  <label class="required">{{ trans.trans('__JSON__.Vendor Name',{ vendor: $auth.setting && $auth.setting.restaurant_name , lang: $auth.langauges[0] && $auth.langauges[0].name}) }}</label>
                  <input
                    id="name"
                    v-model="$v.typeform.name.$model"
                    type="text"
                    class="form-control"
                    :placeholder="trans.trans('__JSON__.Enter Vendor Name langauge',{vendor: $auth.setting && $auth.setting.restaurant_name , lang: $auth.langauges[0] && $auth.langauges[0].name})"
                    name="name"
                    :class="{ 'is-invalid': $v.typeform.name.$error }"
                  />
                  <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.name.required">{{ trans.trans('__JSON__.Please enter vendor name',{ vendor: $auth.setting && $auth.setting.restaurant_name })}}</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 d-none" v-if="$auth.langauges[1].name == 'No Secondary Language'">
              </div>
              <div class="col-sm-6" v-else>
               <div class="form-group" v-if="$auth.setting">
                <label>{{ trans.trans('__JSON__.Vendor Name',{vendor: $auth.setting && $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[0] && $auth.langauges[1].name })}}</label>
                <input
                  maxlength="100"
                  id="name_thai"
                  name="name_thai"
                  type="text"
                  v-model="typeform.name_thai"
                  :placeholder="trans.trans('__JSON__.Enter Vendor Name langauge',{vendor: $auth.setting && $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[0] && $auth.langauges[1].name })"
                  class="form-control"
                />
               </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">{{ trans.get('__JSON__.E-Mail') }}</label>
                  <input
                    id="email"
                    v-model="$v.typeform.email.$model"
                    type="email"
                    name="email"
                    class="form-control"
                    @blur="userCheckEmail"
                    :class="{ 'is-invalid': $v.typeform.email.$error }"
                    placeholder="Enter a valid e-mail"
                  />
                  <div v-if="$v.typeform.email.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                    <span v-if="!$v.typeform.email.email">{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">{{ trans.get('__JSON__.Contact Number') }}</label>
                  <input
                    maxlength="20"
                    minlength="6"
                    id="phone"
                    v-model="$v.typeform.phone.$model"
                    type="text"
                    name="phone"
                    class="form-control"
                    :class="{ 'is-invalid': $v.typeform.phone.$error }"
                    :placeholder="trans.get('__JSON__.Enter Contact Number')"
                    @keypress="contactNumber($event)"
                    @paste.prevent
                    autocomplete="nope"
                  />
                  <!-- 
                    maxlength="10"
                    type="tel" 
                  -->
                  <div v-if="$v.typeform.phone.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.phone.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                    <!-- <span v-if="!$v.typeform.phone.numeric">{{ trans.get('__JSON__.This value should be a valid number') }}</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Vendor Info End -->

        <!-- Location Section Start -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{ trans.get('__JSON__.Location') }}</h4>
            <p class="card-title-desc"></p>

            <div class="row">
              <div class="col-sm-6">
                <div v-if="country_count >1" class="form-group">
                  <label class="control-label required">{{ trans.get('__JSON__.Country') }}</label>
                  <select
                    class="custom-select"
                    v-model="$v.typeform.country.$model"
                    @change="getVendorState"
                    id="country"
                    name="country"
                    :class="{ 'is-invalid': $v.typeform.country.$error }"
                  >
                    <option value selected>{{ trans.get('__JSON__.Select Country') }}</option>
                    <option
                      v-for="con in countries"
                      :value="con.id"
                      :key="con.id"
                    >{{con.country_name}}</option>
                  </select>
                  <div v-if="$v.typeform.country.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.country.required">{{ trans.get('__JSON__.Please select country') }}</span>
                  </div>
                </div>

                <div v-if="(country_count == 1 && state_count > 1) || country_count > 1" class="form-group">
                  <label class="control-label required">{{ trans.get('__JSON__.State') }}</label>
                  <select
                    class="custom-select"
                    v-model="$v.typeform.state.$model"
                    @change="getVendorCity"
                    id="state"
                    name="state"
                    :class="{ 'is-invalid': $v.typeform.state.$error }"
                  >
                    <option value selected>{{ trans.get('__JSON__.Select State') }}</option>
                    <option v-for="sat in states" :value="sat.id" :key="sat.id">{{sat.state_name}}</option>
                  </select>
                  <div v-if="$v.typeform.state.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.state.required">{{ trans.get('__JSON__.Please select state')}}</span>
                  </div>
                </div>

                <div v-if="(country_count == 1 && state_count == 1 && city_count > 1) || country_count > 1 || state_count > 1" class="form-group">
                  <label class="control-label required">{{ trans.get('__JSON__.City') }}</label>
                  <select
                    class="custom-select"
                    v-model="$v.typeform.city.$model"
                    id="city"
                    name="city"
                    :class="{ 'is-invalid': $v.typeform.city.$error }"
                  >
                    <option value selected>{{ trans.get('__JSON__.Select City') }}</option>
                    <option
                      v-for="cit in cities"
                      :value="cit.cityid"
                      :key="cit.cityid"
                    >{{cit.cityname}}</option>
                  </select>
                  <div v-if="$v.typeform.city.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.city.required">{{ trans.get('__JSON__.Please select city') }}</span>
                  </div>
                </div>

                <div class="form-group">
                  <label class="control-label required">{{ trans.get('__JSON__.Search Vendor Location On Google Map') }}</label>
                  <vue-google-autocomplete
                    ref="address"
                    id="addres"
                    name="address"
                    type="text"
                    class="form-control"
                    :placeholder="trans.get('__JSON__.Search Vendor Location On Google Map')"
                    v-model="$v.typeform.address.$model"
                    v-on:placechanged="getAddressData"
                    :class="{'is-invalid':$v.typeform.address.$error}"
                    types=""
                    :country="[$auth.setting.country_code_type]"
                  >
                  </vue-google-autocomplete>
                  <!-- types="establishment" -->
                  <div v-if="$v.typeform.address.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.address.required">{{ trans.get('__JSON__.Please enter address') }}</span>
                  </div>
                </div>

                <div class="form-group">
                  <label class="control-label required">{{ trans.trans('__JSON__.Vendor Full address',{vendor: $auth.setting.restaurant_name} ) }}</label>
                  <input
                    id="location_address"
                    name="location_address"
                    type="text"
                    v-model="$v.typeform.location_address.$model"
                    class="form-control"
                    :placeholder="trans.trans('__JSON__.Enter Vendor full address',{vendor: $auth.setting.restaurant_name})"
                    :class="{ 'is-invalid': $v.typeform.location_address.$error }"
                  />
                  <div v-if="$v.typeform.location_address.$error" class="invalid-feedback">
                    <span
                      v-if="!$v.typeform.location_address.required"
                    >{{ trans.trans('__JSON__.Please enter Vendor full address',{vendor: $auth.setting.restaurant_name}) }}</span>
                  </div>
                </div>

                <div v-if="$auth.langauges[1].name == 'No Secondary Language'" class="form-group d-none">
                </div>
                <div class="form-group" v-else>
                  <label class="control-label">{{ trans.trans('__JSON__.Vendor Full address Secondary Language (Optional)', {vendor: $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[1].name }) }}</label>
                  <input
                    id="address_thai"
                    name="address_thai"
                    type="text"
                    class="form-control"
                    v-model="typeform.address_thai"
                    :placeholder="trans.trans('__JSON__.Enter Vendor full address Secondary language', {vendor: $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[1].name })"
                  />
                </div>
              </div>

              <div class="col-sm-6">
                <div class="map1" id="map" style="height: 100%">
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Location Section End -->

        <!-- Other Info Start -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{ trans.get('__JSON__.Other Info') }}</h4>
            <p class="card-title-desc"></p>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">
                    {{ trans.get('__JSON__.Minimum Order Amount') }} 
                    ( {{ vendor_currency}} )
                  </label>
                  <input
                    @input="filterInput"
                    id="minimum_order_value"
                    name="minimum_order_value"
                    type="text" 
                    v-model="$v.typeform.minimum_order_value.$model"
                    class="form-control"
                    :placeholder="trans.get('__JSON__.Minimum Order Amount')"
                    :class="{ 'is-invalid':$v.typeform.minimum_order_value.$error }"
                  />
                  <div v-if="$v.typeform.minimum_order_value.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.minimum_order_value.required">{{ trans.get('__JSON__.Please enter amount') }}</span>
                    <span
                          v-if="!$v.typeform.minimum_order_value.floating"
                        >{{ trans.get('__JSON__.This value should be digits')}}.</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6" v-if="$auth.setting.is_pickup_enable == true">
                <div class="form-group">
                  <label class="control-label">{{ trans.get('__JSON__.Delivery Type & Time Slots') }}</label>
                  <select
                    class="custom-select"
                    v-model="typeform.delivery_type_time_slots"
                    id="delivery_type_time_slots"
                    name="delivery_type_time_slots"
                  >
                    <option value="">{{ trans.get('__JSON__.Select Delivery Type') }}</option>
                    <option v-bind:value="0">{{ trans.get('__JSON__.Pickup') }}</option>
                    <option v-bind:value="1">{{ trans.get('__JSON__.Delivery') }}</option>
                    <option v-bind:value="2" selected>{{ trans.get('__JSON__.Both') }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label">{{ trans.get('__JSON__.GST',{gst: $auth.getTaxName()})}} (%)</label>
                  <input
                    id="restaurant_tax"
                    name="restaurant_tax"
                    type="text"
                    class="form-control"
                    v-model="$v.typeform.restaurant_tax.model"
                    :placeholder="trans.get('__JSON__.Vendor GST',{gst: $auth.getTaxName()})"
                    v-on:keypress="floatingNumber($event,typeform.restaurant_tax)"
                  />
                </div>
              </div>

              <div class="col-sm-6" v-if="$auth.setting && $auth.setting.restaurant_payment_option == 'Restaurant Select Payment Option'">
                <div class="form-group">
                  <label>{{ trans.get('__JSON__.Payment Option') }}</label>
                 <select
                    class="custom-select"
                    v-model="typeform.payment_option"
                    id="payment_option"
                    name="payment_option"
                  >
                    <option value="Both">{{ trans.get('__JSON__.Both') }}</option>
                    <option value="COD">{{ trans.get('__JSON__.Cash On Delivery') }}</option>
                    <option value="PAY ONLINE">{{ trans.get('__JSON__.PAY ONLINE') }}</option>
                  </select>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <!-- Other Info End -->

        <!-- Vendor Image Start -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title required">{{ trans.trans('__JSON__.Vendor Image',{ vendor: $auth.setting.restaurant_name }) }}</h4>
            <p class="card-title-desc"></p>
            <div class="row">
              <div class="col-sm-3">
                <dropzone-popup
                  v-model="typeform.icon_image"
                  type="file"
                  id="icon_image"
                  name="icon_image"
                  acceptedFiles=".jpeg,.jpg,.png"
                  :class="{ 'is-invalid': $v.typeform.icon_image.$error }"
                />
                <div v-if="$v.typeform.icon_image.$error" class="invalid-feedback cuisine-img">
                  <span
                    v-if="!$v.typeform.icon_image.required"
                  >{{ trans.get('__JSON__.Please select image') }}</span>
                </div>
              </div> 
            </div>

            <div class="row">
              <div class="col-sm-6">
                <button type="submit" class="btn btn-primary mr-1 mt-3">{{ trans.trans('__JSON__.Add Vendor',{ vendor: $auth.setting.restaurant_name }) }}</button>
                <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Vendor Image End -->
      </form>
    </div>
  </div>
  <!-- end row -->
</template>
